import React, {useEffect, useState} from 'react';
import {
  Link,
    useNavigate,
} from "react-router-dom";

import {connect} from 'react-redux';
import Typewriter from 'typewriter-effect';


const columnStyle = {
    height: "calc(50vh)"
}

function AnimatedPersona({
    backgroundColorName,
    personaWords, // ['Employer', 'In-House Payroll Expert', 'HR Manager', 'Employer']
    description,
    pretext,
    cta,
    path
}) {
    const navigate = useNavigate()

    const [animating, setAnimating] = useState()


  return (

        <div className={`w-full md:w-1/3 bg-${backgroundColorName}-900 text-white`} style={columnStyle}
            onMouseEnter={() => setAnimating(true)}
             onMouseLeave={() => setAnimating(false)}
             onClick={() =>{
                 // go to path
                // navigate(path)
             }}
        >
                <div className="md:ml-auto py-20 px-10">
                  <h2 className="text-base font-semibold leading-7 text-buddy">{pretext}</h2>
                  <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                      {animating ?
                          <Typewriter
                          options={{
                            strings: personaWords,
                            autoStart: true,
                            loop: true,

                          }}
                        /> : personaWords[0]}

                  </p>
                  <p className="mt-6 text-base leading-7 text-gray-300">
                      {description}
                  </p>
                  <div className="mt-8">
                    <Link
                      to={path}
                      className="inline-flex rounded-md bg-white/10 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                    >
                        {cta}
                    </Link>
                  </div>
                </div>
              </div>


  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnimatedPersona)
